import blogThumb1 from '../assets/images/blogThumb1.png'
import blogThumb2 from '../assets/images/blogThumb2.jpg'
import blogThumb3 from '../assets/images/blogThumb3.jpg'
import blogThumb4 from '../assets/images/blogThumb4.jpg'
import blogThumb5 from '../assets/images/blogThumb5.jpg'
import blogThumb6 from '../assets/images/blogThumb6.jpg'
import blogThumb7 from '../assets/images/blogThumb7.jpg'
import blogThumb8 from '../assets/images/blogThumb8.jpg'
import blogThumb9 from '../assets/images/blogThumb9.jpg'
import blogThumb10 from '../assets/images/blogThumb10.jpg'
import blogThumb11 from '../assets/images/blogThumb11.jpg'
import blogThumb12 from '../assets/images/blogThumb12.jpg'
import blogThumb13 from '../assets/images/blogThumb13.jpg'
import blogThumb14 from '../assets/images/blogThumb14.jpg'
import blogThumb15 from '../assets/images/blogThumb15.jpg'
import blogThumb16 from '../assets/images/blogThumb16.jpg'
import blogThumb17 from '../assets/images/blogThumb17.jpg'
import blogThumb18 from '../assets/images/blogThumb18.jpg'
import blogThumb19 from '../assets/images/blogThumb19.jpg'
import blogThumb20 from '../assets/images/blogThumb20.jpg'
import blogThumb21 from '../assets/images/blogThumb21.jpg'
import blogThumb22 from '../assets/images/blogThumb22.jpg'
import blogThumb23 from '../assets/images/blogThumb23.jpg'
import blogThumb24 from '../assets/images/blogThumb24.jpg'
import blogThumb25 from '../assets/images/blogThumb25.jpg'
import blogThumb26 from '../assets/images/blogThumb26.jpg'
import blogThumb27 from '../assets/images/blogThumb27.jpg'
import blogThumb28 from '../assets/images/blogThumb28.jpg'
import blogThumb29 from '../assets/images/blogThumb29.jpg'
import blogThumb30 from '../assets/images/blogThumb30.jpg'
import blogThumb31 from '../assets/images/blogThumb31.jpg'
import blogThumb32 from '../assets/images/blogThumb32.jpg'
import blogThumb33 from '../assets/images/blogThumb33.jpg'
import blogThumb34 from '../assets/images/blogThumb34.jpg'
import blogThumb35 from '../assets/images/blogThumb35.jpg'
import blogThumb36 from '../assets/images/blogThumb36.jpg'
import blogThumb37 from '../assets/images/blogThumb37.jpg'
import blogThumb38 from '../assets/images/blogThumb38.jpg'
import blogThumb39 from '../assets/images/blogThumb39.jpg'
import blogThumb40 from '../assets/images/blogThumb40.jpg'
import blogThumb41 from '../assets/images/blogThumb41.jpg'
import blogThumb42 from '../assets/images/blogThumb42.jpg'

import authorAvt1 from '../assets/images/authorAvt1.jpeg'
import authorAvt2 from '../assets/images/authorAvt2.jpg'
import authorAvt4 from '../assets/images/authorAvt4.jpg'
import authorAvt3 from '../assets/images/authorAvt3.jpg'
import authorAvt10 from '../assets/images/authorAvt10.jpg'
import authorAvt8 from '../assets/images/authorAvt8.jpg'

import editorPickedImage1 from '../assets/images/editorPickedImage1.jpg'
import editorPickedImage2 from '../assets/images/editorPickedImage2.jpg'
import editorPickedImage3 from '../assets/images/editorPickedImage3.jpg'
import editorPickedImage4 from '../assets/images/editorPickedImage4.jpg'
import editorPickedImage5 from '../assets/images/editorPickedImage5.jpg'
import editorPickedImage6 from '../assets/images/editorPickedImage6.jpg'
import editorPickedImage7 from '../assets/images/editorPickedImage7.jpg'
import editorPickedImage8 from '../assets/images/editorPickedImage8.jpg'

import highlightThumb1 from '../assets/images/highlightThumb1.jpg'
import highlightThumb2 from '../assets/images/highlightThumb2.jpg'
import highlightThumb3 from '../assets/images/highlightThumb3.jpg'
import highlightThumb4 from '../assets/images/highlightThumb4.jpg'
import highlightThumb5 from '../assets/images/highlightThumb5.jpg'
import highlightThumb6 from '../assets/images/highlightThumb6.jpg'
import highlightThumb7 from '../assets/images/highlightThumb7.jpg'
import highlightThumb8 from '../assets/images/highlightThumb8.jpg'

import blogThumb43 from '../assets/images/blogThumb43.jpg'
import categoryThumb7 from '../assets/images/categoryThumb7.jpg'
import blogThumb44 from '../assets/images/blogThumb44.jpg'
import blogThumb45 from '../assets/images/blogThumb45.jpg'
import blogThumb46 from '../assets/images/blogThumb46.jpg'
import categoryThumb3 from '../assets/images/categoryThumb3.jpg'
import blogThumb47 from '../assets/images/blogThumb47.jpg'
import blogThumb48 from '../assets/images/blogThumb48.jpg'
import blogThumb49 from '../assets/images/blogThumb49.jpg'
import blogThumb50 from '../assets/images/blogThumb50.jpg'
import blogThumb51 from '../assets/images/blogThumb51.jpg'
import blogThumb52 from '../assets/images/blogThumb52.jpg'
import blogThumb53 from '../assets/images/blogThumb53.jpg'
import blogThumb54 from '../assets/images/blogThumb54.jpg'
import blogThumb55 from '../assets/images/blogThumb55.jpg'
import blogThumb56 from '../assets/images/blogThumb56.jpg'
import blogThumb57 from '../assets/images/blogThumb57.jpg'
import blogThumb58 from '../assets/images/blogThumb58.jpg'
import blogThumb59 from '../assets/images/blogThumb59.jpg'
import blogThumb61 from '../assets/images/blogThumb61.jpg'
import blogThumb62 from '../assets/images/blogThumb62.jpg'
import blogThumb63 from '../assets/images/blogThumb63.jpg'
import blogThumb64 from '../assets/images/blogThumb64.jpg'

const initState = {
   blogs: [
      {
         id: 1,
         image: blogThumb1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Blog Post Medium',
         desc: '«Travel is the healthiest addiction»',
         date: 'July 2, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         categories: ['Scott Jackson', 'Agency'],
         styles: {},
         type: 1,
      },
      {
         id: 2,
         image: blogThumb2,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Blog Post Small',
         desc: '«Travel is the healthiest addiction»',
         date: 'July 2, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         categories: ['Scott Jackson', 'Agency', 'Super Simple Blog Post'],
         styles: {},
         type: 1,
      },
      {
         id: 3,
         image: blogThumb3,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'July 2, 2023',
         createdAt: 1686735683881,
         comments: 2,
         styles: {},
         categories: ['Scott Jackson', 'Agency'],
         likes: 0,
         type: 1,
      },
      {
         id: 4,
         image: blogThumb4,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Simple Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'July 2, 2023',
         createdAt: 1686735683881,
         comments: 2,
         categories: ['Scott Jackson', 'Agency'],
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 5,
         image: blogThumb5,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'July 2, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         categories: ['Scott Jackson', 'Agency'],
         styles: {},
         type: 1,
      },
      {
         id: 6,
         image: blogThumb6,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'July 2, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         categories: ['Scott Jackson', 'Agency'],
         styles: {},
         type: 1,
      },
      {
         id: 7,
         image: blogThumb7,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 2,
         categories: ['Scott Jackson', 'Agency', 'ipsum'],
         styles: {},
         type: 1,
      },
      {
         id: 8,
         image: blogThumb8,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 2,
         categories: ['Scott Jackson', 'ipsum'],
         styles: {},
         type: 1,
      },

      {
         id: 9,
         image: blogThumb9,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Double Item Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         categories: ['Scott Jackson', 'Double Item'],
         styles: {},
         type: 4,
      },
      {
         id: 10,
         image: blogThumb10,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         categories: ['Scott Jackson', 'Agency', 'Medium'],
         styles: {},
         type: 4,
      },
      {
         id: 11,
         image: blogThumb11,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 12,
         image: blogThumb12,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 13,
         image: blogThumb13,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 14,
         image: blogThumb14,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 15,
         image: blogThumb15,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 16,
         image: blogThumb16,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 17,
         image: blogThumb17,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 18,
         image: blogThumb18,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },
      {
         id: 19,
         image: blogThumb19,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua lorem ipsum. Dolore magnam aliquam quaerat voluptatem. Nemo enim ipsam voluptatem quia voluptas.',
         date: 'July 3, 2023',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 4,
      },

      {
         id: 20,
         image: blogThumb20,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'You don’t have to be rich to travel well',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam…',
         date: 'November 30, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },

      {
         id: 21,
         image: blogThumb21,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Travel is never a matter of money but of courage',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam…',
         date: 'November 30, 2020',
         createdAt: 1686735683123,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 22,
         image: blogThumb22,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Then I realized adventures are the best way to learn',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam…',
         date: 'November 30, 2020',
         createdAt: 1686735683777,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 23,
         image: blogThumb23,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet, consectetur adipisicing',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam…',
         date: 'October 26, 2020',
         createdAt: 1686735682890,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 24,
         image: blogThumb24,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet, consectetur adipisicing',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam…',
         date: 'October 11, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },

      {
         id: 25,
         image: editorPickedImage6,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Simple Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua. Ut enim ad mini veniam, quis nostrud',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 26,
         image: editorPickedImage7,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Simple Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua. Ut enim ad mini veniam, quis nostrud',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 27,
         image: editorPickedImage8,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Simple Blog Post',
         desc: 'Lorem ipsum dolor sit ametcon sectetur adipisicing elit, sed doiusmod tempor incidi labore et dolore. agna aliqua. Ut enim ad mini veniam, quis nostrud',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 28,
         image: editorPickedImage1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Nathan Matthews',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 29,
         image: editorPickedImage2,
         author: 'Julianna Galanis',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 30,
         image: editorPickedImage3,
         author: 'Mel Granville',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 31,
         image: editorPickedImage4,
         author: 'Cassandra Lynn',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 32,
         image: editorPickedImage5,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: '20 Nov',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 33,
         image: blogThumb25,
         author: 'Small Blog Post',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'October 25, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 34,
         image: blogThumb26,
         author: 'Small Blog Post',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'October 24, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 35,
         image: blogThumb27,
         author: 'Small Blog Post',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'October 24, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 36,
         image: blogThumb28,
         author: 'Small Blog Post',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'October 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 37,
         image: blogThumb29,
         author: 'Small Blog Post',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'October 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 38,
         image: blogThumb30,
         author: 'Small Blog Post',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: '«Travel is the healthiest addiction»',
         date: 'October 19, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },

      {
         id: -99,
         image: null,
         author: 'Scott Jackson',
         avatar: null,
         title: ['Life if a Journey.', 'Make', 'the Best of it.'],
         desc: '',
         createdAt: 1686735683881,
         date: 'July 3, 2023',
         styles: {},
         type: 3,
         comments: 0,
         likes: 0,
      },
      {
         id: -98,
         image: null,
         author: 'Lao Tzu, Chinese philosopher',
         avatar: null,
         title: ['A journey is Best Measured.', 'in Friend,', 'Rather Than Miles'],
         desc: '',
         createdAt: 1686735683881,
         date: 'July 3, 2023',
         styles: {},
         type: 3,
         comments: 0,
         likes: 0,
      },

      // travel highlights
      {
         id: 39,
         image: highlightThumb1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['argentina', 'europe'],
         type: 1,
      },
      {
         id: 40,
         image: highlightThumb2,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['argentina', 'brazil'],
         type: 1,
      },
      {
         id: 41,
         image: highlightThumb3,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['brazil', 'europe'],
         type: 1,
      },
      {
         id: 42,
         image: highlightThumb4,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['brazil', 'mexico'],
         type: 1,
      },
      {
         id: 43,
         image: highlightThumb5,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['argentina', 'mexico'],
         type: 1,
      },
      {
         id: 44,
         image: highlightThumb6,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['europe', 'mexico'],
         type: 1,
      },
      {
         id: 45,
         image: highlightThumb7,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['mexico'],
         type: 1,
      },
      {
         id: 46,
         image: highlightThumb8,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip et dolore magna',
         date: 'July 3, 2021',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['argentina', 'brazil', 'mexico'],
         type: 1,
      },

      // moreBlogsByAuthor
      {
         id: 47,
         image: blogThumb25,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 48,
         image: blogThumb27,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 49,
         image: blogThumb31,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 50,
         image: blogThumb32,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 51,
         image: blogThumb35,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 52,
         image: blogThumb33,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 53,
         image: blogThumb34,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 54,
         image: null,
         author: 'Paulo Coelho, Brazilian writer',
         avatar: null,
         title: ['If you think adventure is dangerous', 'try routine,', "it's lethal"],
         desc: '',
         createdAt: 1686735683881,
         date: 'July 3, 2023',
         styles: {},
         comments: 0,
         likes: 0,
         type: 3,
      },
      {
         id: 55,
         image: blogThumb39,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 56,
         image: blogThumb37,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 57,
         image: blogThumb38,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 58,
         image: blogThumb36,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 59,
         image: blogThumb40,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 60,
         image: blogThumb42,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },
      {
         id: 61,
         image: blogThumb41,
         author: 'Herman Ledford',
         avatar: authorAvt1,
         title: 'Super Simple Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
         date: 'November 18, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         styles: {},
         type: 2,
      },

      // blog feed 2
      {
         id: 62,
         image: editorPickedImage3,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 63,
         image: blogThumb43,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 64,
         image: blogThumb5,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 65,
         image: editorPickedImage4,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 66,
         image: blogThumb19,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 67,
         image: categoryThumb7,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 68,
         image: blogThumb44,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 69,
         image: blogThumb45,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 70,
         image: blogThumb30,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 71,
         image: blogThumb46,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 72,
         image: categoryThumb3,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 73,
         image: blogThumb22,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 74,
         image: blogThumb47,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 75,
         image: blogThumb48,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 76,
         image: blogThumb49,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 77,
         image: editorPickedImage6,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 78,
         image: blogThumb50,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 79,
         image: blogThumb51,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 80,
         image: blogThumb14,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 81,
         image: blogThumb52,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 82,
         image: blogThumb53,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 83,
         image: blogThumb54,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 84,
         image: blogThumb55,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 85,
         image: blogThumb7,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 86,
         image: blogThumb56,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },
      {
         id: 87,
         image: blogThumb10,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683881,
         comments: 2,
         likes: 0,
         styles: {},
         type: 1,
      },

      // travel blogs
      {
         id: 88,
         image: blogThumb7,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735681123,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['active', 'reviews'],
         type: 2,
      },
      {
         id: 89,
         image: blogThumb8,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735682222,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['routes'],
         type: 2,
      },
      {
         id: 90,
         image: highlightThumb4,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735685555,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['travel'],
         type: 2,
      },
      {
         id: 91,
         image: editorPickedImage4,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735688888,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['travel', 'reviews'],
         type: 2,
      },
      {
         id: 92,
         image: blogThumb57,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735689999,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['active', 'reviews'],
         type: 2,
      },
      {
         id: 93,
         image: blogThumb58,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735687777,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['active', 'routes'],
         type: 2,
      },
      {
         id: 94,
         image: blogThumb59,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735681777,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['reviews'],
         type: 2,
      },
      {
         id: 95,
         image: blogThumb8,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735682777,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['reviews', 'travel'],
         type: 2,
      },
      {
         id: 96,
         image: highlightThumb4,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Lorem ipsum dolor sit amet',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
         styles: {},
         categories: ['active', 'travel'],
         type: 2,
      },

      // featured posts by author
      {
         id: 97,
         image: blogThumb61,
         author: 'Nathan Matthews',
         role: 'TheGem Blogger',
         avatar: authorAvt2,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 98,
         image: blogThumb61,
         author: 'Nathan Matthews',
         role: 'TheGem Blogger',
         avatar: authorAvt2,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 14, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 99,
         image: blogThumb5,
         author: 'Nathan Matthews',
         role: 'TheGem Blogger',
         avatar: authorAvt2,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 14, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 100,
         image: blogThumb19,
         author: 'Nathan Matthews',
         role: 'TheGem Blogger',
         avatar: authorAvt2,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 11, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 101,
         image: blogThumb6,
         author: 'Nathan Matthews',
         role: 'TheGem Blogger',
         avatar: authorAvt2,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 7, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 102,
         image: blogThumb9,
         author: 'Herman Ledford',
         role: 'TheGem Blogger',
         avatar: authorAvt4,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 103,
         image: blogThumb12,
         author: 'Herman Ledford',
         role: 'TheGem Blogger',
         avatar: authorAvt4,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 104,
         image: blogThumb13,
         author: 'Herman Ledford',
         role: 'TheGem Blogger',
         avatar: authorAvt4,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 105,
         image: blogThumb11,
         author: 'Herman Ledford',
         role: 'TheGem Blogger',
         avatar: authorAvt4,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 106,
         image: blogThumb14,
         author: 'Herman Ledford',
         role: 'TheGem Blogger',
         avatar: authorAvt4,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 107,
         image: editorPickedImage2,
         author: 'Julianna Galanis',
         role: 'TheGem Blogger',
         avatar: authorAvt3,
         slogan: `Lets you indulge in your passion for travel!`,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 108,
         image: blogThumb25,
         author: 'Julianna Galanis',
         role: 'TheGem Blogger',
         avatar: authorAvt3,
         slogan: `Lets you indulge in your passion for travel!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 109,
         image: blogThumb27,
         author: 'Julianna Galanis',
         role: 'TheGem Blogger',
         avatar: authorAvt3,
         slogan: `Lets you indulge in your passion for travel!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 110,
         image: blogThumb31,
         author: 'Julianna Galanis',
         role: 'TheGem Blogger',
         avatar: authorAvt3,
         slogan: `Lets you indulge in your passion for travel!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 111,
         image: blogThumb32,
         author: 'Julianna Galanis',
         role: 'TheGem Blogger',
         avatar: authorAvt3,
         slogan: `Lets you indulge in your passion for travel!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 112,
         image: editorPickedImage3,
         author: 'Mel Granville',
         role: 'TheGem Blogger',
         avatar: authorAvt10,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 113,
         image: blogThumb26,
         author: 'Mel Granville',
         role: 'TheGem Blogger',
         avatar: authorAvt10,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 114,
         image: blogThumb28,
         author: 'Mel Granville',
         role: 'TheGem Blogger',
         avatar: authorAvt10,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 115,
         image: highlightThumb7,
         author: 'Mel Granville',
         role: 'TheGem Blogger',
         avatar: authorAvt10,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 116,
         image: blogThumb62,
         author: 'Mel Granville',
         role: 'TheGem Blogger',
         avatar: authorAvt10,
         slogan: `Then I realized\nadventure are way to learn!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 117,
         image: editorPickedImage4,
         author: 'Cassandra Lynn',
         role: 'TheGem Blogger',
         avatar: authorAvt8,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Medium Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 118,
         image: blogThumb29,
         author: 'Cassandra Lynn',
         role: 'TheGem Blogger',
         avatar: authorAvt8,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 119,
         image: blogThumb30,
         author: 'Cassandra Lynn',
         role: 'TheGem Blogger',
         avatar: authorAvt8,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 120,
         image: blogThumb63,
         author: 'Cassandra Lynn',
         role: 'TheGem Blogger',
         avatar: authorAvt8,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
      {
         id: 121,
         image: blogThumb64,
         author: 'Cassandra Lynn',
         role: 'TheGem Blogger',
         avatar: authorAvt8,
         slogan: `Wherever you go, go \n with all your heart!`,
         title: 'Small Blog Post',
         desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim ad minim veniam, quis ut aliquip exea',
         date: 'November 23, 2020',
         createdAt: 1686735683888,
         comments: 2,
         likes: 0,
      },
   ],

   blogFeed: [
      { blogId: 1, type: 1, styles: {} },
      { blogId: 2, type: 1, styles: { small: true, noOverlayContent: true } },
      { blogId: 3, type: 1, styles: { small: true, visual: true } },
      { blogId: 4, type: 1, styles: { extraSmall: true, visual: true } },
      { blogId: 5, type: 1, styles: { extraSmall: true, visual: true } },
      { blogId: -99, type: 3 },
      { blogId: 6, type: 1, styles: { extraSmall: true, visual: true } },
      { blogId: 7, type: 2 },
      { blogId: 8, type: 2 },
   ],

   blogFeed2: [
      { blogId: 62, type: 1, styles: { square: true, visual: true } },
      { blogId: 63, type: 1, styles: { square: true, visual: true } },
      { blogId: 64, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 65, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 66, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 67, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 68, type: 1, styles: { square: true, visual: true } },
      { blogId: 69, type: 1, styles: { square: true, visual: true } },
      { blogId: 70, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 71, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 72, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 73, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 74, type: 1, styles: { square: true, visual: true } },
      { blogId: 75, type: 1, styles: { square: true, visual: true } },
      { blogId: 76, type: 1, styles: { square: true, visual: true } },
      { blogId: 77, type: 1, styles: { square: true, visual: true } },
      { blogId: 78, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 79, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 80, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 81, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 82, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 83, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 84, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 85, type: 1, styles: { square: true, visual: true, squareSmall: true } },
      { blogId: 86, type: 1, styles: { square: true, visual: true } },
      { blogId: 87, type: 1, styles: { square: true, visual: true } },
   ],

   blogGallery: [9, 10, 11, 12, 13, -98, 14, 15, 16, 17, 18, 19],

   recentPosts: [20, 21, 22, 23, 24],

   editorPinkedNews: [25, 26, 27, 28, 29, 30, 31, 32],

   moreStories: [25, 26, 27, 4, 5, 19, 6, 12, 33, 34, 13, 35, 36, 37, 38],

   blogHighlights: [39, 40, 41, 42, 43, 44, 45, 46],

   moreBlogsByAuthor: [47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61],

   travelBlogs: [88, 89, 90, 91, 92, 93, 94, 95, 96],

   featuredBlogsByAuthor: [
      {
         main: 97,
         subs: [98, 99, 100, 101],
      },
      {
         main: 102,
         subs: [103, 104, 105, 106],
      },
      {
         main: 107,
         subs: [108, 109, 110, 111],
      },
      {
         main: 112,
         subs: [113, 114, 115, 116],
      },
      {
         main: 117,
         subs: [118, 119, 120, 121],
      },
   ],

   relatedPosts: [84, 69, 41, 31, 19, 20, 59, 6, 8, 34, 51, 42, 36, 30, 38],
}

function blogReducer(state = initState, action) {
   switch (action.type) {
      case '':
         return state

      default:
         return state
   }
}

export default blogReducer
